/* onChange function are mainly interested in the value, not the event.
This function simplifies implementation & returns the event as a second argument */
import type { ChangeEvent, ChangeEventHandler } from 'react';

export function handleNativeInputEvent<V, E>(
  onChange?: (value: V, event: ChangeEvent<E>) => void,
): undefined | ChangeEventHandler<E> {
  return typeof onChange === 'function' ? (e: ChangeEvent<E>) => onChange((e.target as any).value, e) : undefined;
}
